module.exports = __webpack_public_path__ + "static/media/instagram-orange.c6a09afd.svg";